import type { Theme } from '@mui/material';

export const styles = {
  logicalOperator: {
    backgroundColor: 'transparent',
    borderRadius: '0.5rem',
    margin: '0.5rem',
    alignItems: 'center',
  },

  button: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[600],
    color: theme.colors.white,
    border: 'none',
    height: '100%',

    '&:hover:not(:disabled)': {
      backgroundColor: theme.colors.neutral[500],
      color: theme.colors.white,
    },
  }),
};
